import { WebPlugin } from '@capacitor/core';
export class QonversionWeb extends WebPlugin {
    addAttributionData(params) {
        throw this.unimplemented("not implemented yet");
    }
    attachUserToExperiment(params) {
        throw this.unimplemented("not implemented yet");
    }
    attachUserToRemoteConfiguration(params) {
        throw this.unimplemented("not implemented yet");
    }
    checkEntitlements() {
        throw this.unimplemented("not implemented yet");
    }
    checkTrialIntroEligibility(params) {
        throw this.unimplemented("not implemented yet");
    }
    collectAdvertisingId() {
        throw this.unimplemented("not implemented yet");
    }
    collectAppleSearchAdsAttribution() {
        throw this.unimplemented("not implemented yet");
    }
    detachUserFromExperiment(params) {
        throw this.unimplemented("not implemented yet");
    }
    detachUserFromRemoteConfiguration(params) {
        throw this.unimplemented("not implemented yet");
    }
    getPromotionalOffer(params) {
        throw this.unimplemented("not implemented yet");
    }
    identify(params) {
        throw this.unimplemented("not implemented yet");
    }
    initialize(params) {
        throw this.unimplemented("not implemented yet");
    }
    isFallbackFileAccessible() {
        throw this.unimplemented("not implemented yet");
    }
    logout() {
        throw this.unimplemented("not implemented yet");
    }
    offerings() {
        throw this.unimplemented("not implemented yet");
    }
    presentCodeRedemptionSheet() {
        throw this.unimplemented("not implemented yet");
    }
    products() {
        throw this.unimplemented("not implemented yet");
    }
    promoPurchase(params) {
        throw this.unimplemented("not implemented yet");
    }
    purchase(params) {
        throw this.unimplemented("not implemented yet");
    }
    remoteConfig(params) {
        throw this.unimplemented("not implemented yet");
    }
    remoteConfigList(params) {
        throw this.unimplemented("not implemented yet");
    }
    invalidateRemoteConfigsCache() {
        throw this.unimplemented("not implemented yet");
    }
    restore() {
        throw this.unimplemented("not implemented yet");
    }
    setCustomUserProperty(param) {
        throw this.unimplemented("not implemented yet");
    }
    setDefinedUserProperty(param) {
        throw this.unimplemented("not implemented yet");
    }
    storeSdkInfo(params) {
        throw this.unimplemented("not implemented yet");
    }
    syncHistoricalData() {
        throw this.unimplemented("not implemented yet");
    }
    syncPurchases() {
        throw this.unimplemented("not implemented yet");
    }
    syncStoreKit2Purchases() {
        throw this.unimplemented("not implemented yet");
    }
    userInfo() {
        throw this.unimplemented("not implemented yet");
    }
    userProperties() {
        throw this.unimplemented("not implemented yet");
    }
    forceSendProperties() {
        throw this.unimplemented("not implemented yet");
    }
}
//# sourceMappingURL=web.js.map